import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "./primitives";

const FAQS = [
  { q: "What is BulkContainer™?", a: "BulkContainer™ is a DeMaxtore Workspace Product for sourcing large-volume products directly from verified Turkish manufacturers. Instead of combining products from multiple suppliers, you purchase full-container or bulk quantities from one selected manufacturer and manage the entire procurement operation inside one connected Workspace." },
  { q: "Can I order full containers?", a: "Yes. BulkContainer™ is built for full-container (FCL) and bulk quantity orders. You confirm your volume, packaging and Incoterm, and manage container allocation and shipment directly from your Workspace." },
  { q: "Can I buy directly from manufacturers?", a: "Absolutely. You purchase directly from verified manufacturers at factory-direct prices. DeMaxtore coordinates the procurement operation but does not buy or sell products, and there are no product markups." },
  { q: "Can I manage production progress?", a: "Yes. Your Workspace gives you real-time visibility into factory capacity, production progress, quality status and estimated completion — so you always know exactly where your order stands." },
  { q: "How does FreightIQ™ integrate?", a: "FreightIQ™ is connected natively. Once production is confirmed, you coordinate inspection and book freight through FreightIQ™ without leaving your Workspace, keeping every stage linked." },
  { q: "Can I track shipments inside the Workspace?", a: "Yes. Live Shipment Tracking™ is built into the ecosystem, so you follow your container from departure to delivery alongside all your order documents and milestones." },
];

export default function Faq() {
  return (
    <section id="faq" className="py-24 md:py-32">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading align="center" eyebrow="FAQ" title="Questions, answered." />
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-slate-200">
                <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-[#0A1128] hover:no-underline [&[data-state=open]]:text-[#0052FF]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-[15px] leading-relaxed text-[#64748B]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
